// extracted by mini-css-extract-plugin
module.exports = {"shareBgColor":"ChannelTable_shareBgColor__DWfVq"};